import { FC } from "react";

type Props = {
  width?: number | string;
  height?: number | string;
  className?: string;
};

const PdfIcon: FC<Props> = ({ width = 18, height = 18, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="32" height="32" rx="5" fill="#E41E25" />
    <path
      d="M23.5 15.2C22.6 14.8 21.2 14.6 19.5 14.7C18.4 14.1 17.5 13.2 16.8 11.9C17.2 10.4 17.4 9 17.4 7.9C17.4 7.1 17.2 6.5 16.8 6.2C16.5 6 16.1 5.9 15.7 5.9C14.9 5.9 14.3 6.6 14.3 7.8C14.3 9.4 14.9 11.5 15.8 13.6C15.2 15.4 14.4 17.1 13.5 18.6C12.9 19.6 12.3 20.4 11.6 21.1C9.8 21.8 8.5 22.8 8.5 24C8.5 24.8 8.9 25.4 9.6 25.8C10 26 10.5 26.1 11 26.1C12.3 26.1 13.9 25 15.6 22.9C16.8 22.3 18.2 21.7 19.8 21.2C21.1 22 22.4 22.4 23.3 22.4C24.1 22.4 24.7 22 25 21.4C25.3 20.8 25.1 20 24.5 19.3C23.8 18.5 22.2 17.9 20 18.1C20.6 17.1 21.1 16.1 21.5 15.2H23.5ZM10.5 24.6C10.1 24.4 9.9 24.1 9.9 23.8C9.9 23.3 10.6 22.7 11.8 22.2C11.9 22.6 11.7 23.4 10.5 24.6ZM15.7 7.5C15.9 7.5 16 7.6 16.1 7.8C16.1 8.2 15.9 9.3 15.6 10.6C15.3 9.2 15.3 8.3 15.4 7.8C15.5 7.6 15.6 7.5 15.7 7.5ZM17.4 18.8C16.9 17.8 16.4 16.7 16 15.8C16.6 16.7 17.3 17.4 18.1 18.1C17.9 18.3 17.6 18.6 17.4 18.8ZM23.8 20.8C23.6 21 23.3 21.1 23 21.1C22.4 21.1 21.5 20.7 20.4 20C21.8 19.8 22.9 20.1 23.5 20.5C23.7 20.6 23.8 20.7 23.8 20.8Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default PdfIcon;
